import { getCWOPA, LoginManager, getUserDisplayName, getUserRole, getTesterId } from "./LoginManager";
import * as User from "../interfaces/userInfo.interafce";

export class CurrentUser {
  private static current: User.UserInfo | null;

  static async get(): Promise<User.UserInfo | null> {
    if (CurrentUser.current) { return CurrentUser.current; }
    const manager = new LoginManager();
    const openIDUser = await manager.getCurrentUser();
    if (!openIDUser) { return { cwopa: "" } as User.UserInfo }
    let cwopa = getCWOPA(openIDUser);
    
    let displayName = getUserDisplayName(openIDUser);
    
    if (!cwopa) {
      throw new Error("User information missing valid CWOPA");
    }

    let role = getUserRole(openIDUser);

    let testerId = getTesterId(openIDUser);

    var photoUrl = "";

    let user: User.UserInfo | null = { userId: 1, cwopa: cwopa, displayName: displayName, photo: photoUrl, role: role, testerId:testerId } as User.UserInfo;    
    CurrentUser.current = user;
    
    return user;
  }

  static clear() {
    CurrentUser.current = null;
  }
}
